// extracted by mini-css-extract-plugin
export default {"Path":"LightToggle_Path__xlpF-"};